import type { FC } from 'react';
import { Modal as AntModal, type ModalProps } from 'antd';

export const Modal: FC<ModalProps> = props => {
  const { children, ...restProps } = props;

  return <AntModal {...restProps}>{children}</AntModal>;
};
